import type { IconNode } from '../types';

/**
 * @name kebab
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIgMTIgNC4yLTQuMmMuNC0uNC40LTEgLjEtMS41YTIuOSAyLjkgMCAxIDEgNC44LjgiIC8+CiAgPHBhdGggZD0iTTE1LjMgMTEuM2MuOS45LjkgMi41IDAgMy40bC0xLjYgMS42Yy0uOS45LTIuNS45LTMuNCAwIC45LjkuOSAyLjUgMCAzLjRsLTEuNiAxLjZjLS45LjktMi41LjktMy40IDBsLTIuNi0yLjZjLS45LS45LS45LTIuNSAwLTMuNGwxLjYtMS42Yy45LS45IDIuNS0uOSAzLjQgMC0uOS0uOS0uOS0yLjUgMC0zLjRsMS42LTEuNmMuOS0uOSAyLjUtLjkgMy40IDBaIiAvPgogIDxwYXRoIGQ9Im0xMC4zIDE2LjMtMi42LTIuNiIgLz4KICA8cGF0aCBkPSJtOSAxNS0yIDIiIC8+CiAgPHBhdGggZD0ibTIgMjIgMi0yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/kebab
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const kebab: IconNode = [
  ['path', { d: 'm12 12 4.2-4.2c.4-.4.4-1 .1-1.5a2.9 2.9 0 1 1 4.8.8', key: 'q7a8j3' }],
  [
    'path',
    {
      d: 'M15.3 11.3c.9.9.9 2.5 0 3.4l-1.6 1.6c-.9.9-2.5.9-3.4 0 .9.9.9 2.5 0 3.4l-1.6 1.6c-.9.9-2.5.9-3.4 0l-2.6-2.6c-.9-.9-.9-2.5 0-3.4l1.6-1.6c.9-.9 2.5-.9 3.4 0-.9-.9-.9-2.5 0-3.4l1.6-1.6c.9-.9 2.5-.9 3.4 0Z',
      key: '4gm1z9',
    },
  ],
  ['path', { d: 'm10.3 16.3-2.6-2.6', key: 'kfwtld' }],
  ['path', { d: 'm9 15-2 2', key: '15u931' }],
  ['path', { d: 'm2 22 2-2', key: 'neeo2w' }],
];

export default kebab;
